import React, { memo } from 'react';
import { isEmpty } from 'lodash';
import GraphContainerComponent from './container';
import { buildGraphOption } from '../../helper';
import { AGGREGATIONS_FOR_GRAPH } from '../../const';

function Graph(props) {
  const { metric, chargerMetrics, start, end, offset, isRealTime, demo } = props;
  const dataKeys = Object.keys(chargerMetrics);
  const withAggregation = AGGREGATIONS_FOR_GRAPH.some((agg) => Object.prototype.hasOwnProperty.call(chargerMetrics, agg));

  const option = buildGraphOption({
    metric,
    chargerMetrics,
    dataKeys,
    start,
    end,
    offset,
    isHistory: !isRealTime,
    withAggregation,
    isDemo: demo,
  });

  const noData = option?.series.every(({ data }) => isEmpty(data));

  return (
    <GraphContainerComponent
      metric={metric}
      dates={dataKeys}
      chargerMetrics={chargerMetrics}
      noData={noData}
      option={option}
      offset={offset}
      isRealTime={isRealTime}
      isDemo={!!demo}
    />
  );
}

export default memo(Graph);
